/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '@angular/common';
import * as i2 from '../../../$$_gendir/node_modules/ng2-completer/components/completer-cmp.ngfactory';
import * as i3 from 'ng2-completer/components/completer-cmp';
import * as i4 from 'ng2-completer/services/completer-service';
import * as i5 from '@angular/forms';
import * as i6 from '../../../app/components/comms-form';
import * as i7 from '@ngrx/store/src/store';
import * as i8 from '@ngrx/effects/src/actions';
import * as i9 from '@angular/router';
import * as i10 from 'angular2-token';
import * as i11 from '@angular/platform-browser';
const styles_CommsFormComponent:any[] = ([] as any[]);
export const RenderType_CommsFormComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_CommsFormComponent,data:{}});
function View_CommsFormComponent_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'div',[['class',
      'cf__flash']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted(-1,(null as any),['Successfully sent communication']))],(null as any),
      (null as any));
}
function View_CommsFormComponent_3(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),3,'li',[['class',
      'cf__recipient']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted(1,(null as any),['',''])),(_l()(),i0.ɵeld(2,0,(null as any),
          (null as any),1,'span',([] as any[]),(null as any),[[(null as any),'click']],
          (_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.clickedRemoveRecipient(_v.context.$implicit)) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),(_l()(),i0.ɵted(-1,(null as any),['×']))],
      (null as any),(_ck,_v) => {
        const currVal_0:any = _v.context.$implicit.title;
        _ck(_v,1,0,currVal_0);
      });
}
function View_CommsFormComponent_2(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),5,'div',[['class',
      'cf__recipients-wrapper']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i0.ɵeld(1,0,(null as any),(null as any),1,'div',[['class',
      'cf__recipients-label']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i0.ɵted(2,(null as any),['Target recipients (will be sent to ',
      ')'])),(_l()(),i0.ɵeld(3,0,(null as any),(null as any),2,'ul',[['class','cf__recipients']],
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CommsFormComponent_3)),
      i0.ɵdid(5,802816,(null as any),0,i1.NgForOf,[i0.ViewContainerRef,i0.TemplateRef,
          i0.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_1:any = _co.recipients;
    _ck(_v,5,0,currVal_1);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.numberOfRecipients;
    _ck(_v,2,0,currVal_0);
  });
}
function View_CommsFormComponent_4(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),10,'div',[['class',
      'input-row']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵeld(1,0,(null as any),(null as any),9,'div',[['class','input-group']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵeld(2,0,(null as any),(null as any),8,'div',[['class','ig__content-wrapper']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵeld(3,0,(null as any),(null as any),5,'ng2-completer',[['id','send-to-picker'],
          ['name','send-to-picker']],[[2,'ng-untouched',(null as any)],[2,'ng-touched',
          (null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],
          [2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',
              (null as any)]],[[(null as any),'ngModelChange'],[(null as any),'selected']],
          (_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('ngModelChange' === en)) {
              const pd_0:any = ((<any>(_co.sendToSearchStr = $event)) !== false);
              ad = (pd_0 && ad);
            }
            if (('selected' === en)) {
              const pd_1:any = ((<any>_co.selectedSendTo($event)) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },i2.View_CompleterCmp_0,i2.RenderType_CompleterCmp)),i0.ɵdid(4,12697600,
          (null as any),0,i3.CompleterCmp,[i4.CompleterService,i0.ChangeDetectorRef],
          {minSearchLength:[0,'minSearchLength'],openOnFocus:[1,'openOnFocus'],datasource:[2,
              'datasource']},{selected:'selected'}),i0.ɵprd(1024,(null as any),i5.NG_VALUE_ACCESSOR,
          (p0_0:any) => {
            return [p0_0];
          },[i3.CompleterCmp]),i0.ɵdid(6,671744,(null as any),0,i5.NgModel,[[8,(null as any)],
          [8,(null as any)],[8,(null as any)],[2,i5.NG_VALUE_ACCESSOR]],{name:[0,'name'],
          model:[1,'model']},{update:'ngModelChange'}),i0.ɵprd(2048,(null as any),
          i5.NgControl,(null as any),[i5.NgModel]),i0.ɵdid(8,16384,(null as any),0,
          i5.NgControlStatus,[i5.NgControl],(null as any),(null as any)),(_l()(),i0.ɵeld(9,
          0,(null as any),(null as any),1,'label',[['for','send-to-picker']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i0.ɵted(-1,
          (null as any),['Who to send to?']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_7:any = 0;
    const currVal_8:any = true;
    const currVal_9:any = _co.sendToSearchCompleter;
    _ck(_v,4,0,currVal_7,currVal_8,currVal_9);
    const currVal_10:any = 'send-to-picker';
    const currVal_11:any = _co.sendToSearchStr;
    _ck(_v,6,0,currVal_10,currVal_11);
  },(_ck,_v) => {
    const currVal_0:any = i0.ɵnov(_v,8).ngClassUntouched;
    const currVal_1:any = i0.ɵnov(_v,8).ngClassTouched;
    const currVal_2:any = i0.ɵnov(_v,8).ngClassPristine;
    const currVal_3:any = i0.ɵnov(_v,8).ngClassDirty;
    const currVal_4:any = i0.ɵnov(_v,8).ngClassValid;
    const currVal_5:any = i0.ɵnov(_v,8).ngClassInvalid;
    const currVal_6:any = i0.ɵnov(_v,8).ngClassPending;
    _ck(_v,3,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
  });
}
function View_CommsFormComponent_5(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),3,'div',[['class',
      'cf__special-enquiry-form-notice']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i0.ɵted(-1,(null as any),['Note: You are sending the "online-enrolment-email-template" to '])),
      (_l()(),i0.ɵeld(2,0,(null as any),(null as any),1,'span',([] as any[]),(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i0.ɵted(3,
          (null as any),['',' (',')']))],(null as any),(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.enquiryName;
    const currVal_1:any = _co.enquirySendTo;
    _ck(_v,3,0,currVal_0,currVal_1);
  });
}
function View_CommsFormComponent_7(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),3,'button',[['class',
      'cf__btn-toggle-variable-preview tiny']],[[8,'disabled',0]],[[(null as any),
      'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.clickedToggleVariablePreview()) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any))),i0.ɵdid(1,278528,(null as any),0,i1.NgClass,[i0.IterableDiffers,
      i0.KeyValueDiffers,i0.ElementRef,i0.Renderer],{klass:[0,'klass'],ngClass:[1,
      'ngClass']},(null as any)),i0.ɵpod(2,{'disabled':0}),(_l()(),i0.ɵted(3,(null as any),
      ['',' variable preview']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_1:any = 'cf__btn-toggle-variable-preview tiny';
    const currVal_2:any = _ck(_v,2,0,!_co.isToggleVariablePreviewEnabled());
    _ck(_v,1,0,currVal_1,currVal_2);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:boolean = !_co.isToggleVariablePreviewEnabled();
    _ck(_v,0,0,currVal_0);
    const currVal_3:any = (_co.isInVariablePreviewMode? 'Disable': 'Enable');
    _ck(_v,3,0,currVal_3);
  });
}
function View_CommsFormComponent_8(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),3,'button',[['class',
      'cf__btn-send short']],[[8,'disabled',0]],[[(null as any),'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.clickedSend()) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any))),i0.ɵdid(1,278528,(null as any),0,i1.NgClass,[i0.IterableDiffers,
      i0.KeyValueDiffers,i0.ElementRef,i0.Renderer],{klass:[0,'klass'],ngClass:[1,
      'ngClass']},(null as any)),i0.ɵpod(2,{'disabled':0,'loading':1}),(_l()(),i0.ɵted(3,
      (null as any),['Send ','']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_1:any = 'cf__btn-send short';
    const currVal_2:any = _ck(_v,2,0,!_co.isFormvalid(),_co.isSendingComm);
    _ck(_v,1,0,currVal_1,currVal_2);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:boolean = !_co.isFormvalid();
    _ck(_v,0,0,currVal_0);
    const currVal_3:any = _co.mode;
    _ck(_v,3,0,currVal_3);
  });
}
function View_CommsFormComponent_9(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),10,'div',[['class',
      'input-row']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵeld(1,0,(null as any),(null as any),9,'div',[['class','input-group']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵeld(2,0,(null as any),(null as any),8,'div',[['class','cf__variable-preview-picker']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵeld(3,0,(null as any),(null as any),5,'ng2-completer',[['id','variable-preview'],
          ['name','variable-preview']],[[2,'ng-untouched',(null as any)],[2,'ng-touched',
          (null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],
          [2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',
              (null as any)]],[[(null as any),'ngModelChange'],[(null as any),'selected']],
          (_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('ngModelChange' === en)) {
              const pd_0:any = ((<any>(_co.variablePreviewSearchStr = $event)) !== false);
              ad = (pd_0 && ad);
            }
            if (('selected' === en)) {
              const pd_1:any = ((<any>_co.selectedVariablePreview($event)) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },i2.View_CompleterCmp_0,i2.RenderType_CompleterCmp)),i0.ɵdid(4,12697600,
          (null as any),0,i3.CompleterCmp,[i4.CompleterService,i0.ChangeDetectorRef],
          {minSearchLength:[0,'minSearchLength'],openOnFocus:[1,'openOnFocus'],datasource:[2,
              'datasource']},{selected:'selected'}),i0.ɵprd(1024,(null as any),i5.NG_VALUE_ACCESSOR,
          (p0_0:any) => {
            return [p0_0];
          },[i3.CompleterCmp]),i0.ɵdid(6,671744,(null as any),0,i5.NgModel,[[8,(null as any)],
          [8,(null as any)],[8,(null as any)],[2,i5.NG_VALUE_ACCESSOR]],{name:[0,'name'],
          model:[1,'model']},{update:'ngModelChange'}),i0.ɵprd(2048,(null as any),
          i5.NgControl,(null as any),[i5.NgModel]),i0.ɵdid(8,16384,(null as any),0,
          i5.NgControlStatus,[i5.NgControl],(null as any),(null as any)),(_l()(),i0.ɵeld(9,
          0,(null as any),(null as any),1,'label',[['for','variable-preview']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i0.ɵted(-1,
          (null as any),['See merge variables for...']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_7:any = 0;
    const currVal_8:any = true;
    const currVal_9:any = _co.variablePreviewCompleter;
    _ck(_v,4,0,currVal_7,currVal_8,currVal_9);
    const currVal_10:any = 'variable-preview';
    const currVal_11:any = _co.variablePreviewSearchStr;
    _ck(_v,6,0,currVal_10,currVal_11);
  },(_ck,_v) => {
    const currVal_0:any = i0.ɵnov(_v,8).ngClassUntouched;
    const currVal_1:any = i0.ɵnov(_v,8).ngClassTouched;
    const currVal_2:any = i0.ɵnov(_v,8).ngClassPristine;
    const currVal_3:any = i0.ɵnov(_v,8).ngClassDirty;
    const currVal_4:any = i0.ɵnov(_v,8).ngClassValid;
    const currVal_5:any = i0.ɵnov(_v,8).ngClassInvalid;
    const currVal_6:any = i0.ɵnov(_v,8).ngClassPending;
    _ck(_v,3,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
  });
}
function View_CommsFormComponent_10(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'div',[['class',
      'cf__edit-warning']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i0.ɵted(-1,(null as any),['Note: You\'re working with an edited version of the original template']))],
      (null as any),(null as any));
}
function View_CommsFormComponent_11(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'button',[['class',
      'cf__btn-customise tiny']],(null as any),[[(null as any),'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.clickedCustomiseTemplate()) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any))),(_l()(),i0.ɵted(1,(null as any),['','']))],(null as any),
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = (_co.isUsingCustomisedTemplate? 'Use original template': 'Use customised template');
        _ck(_v,1,0,currVal_0);
      });
}
function View_CommsFormComponent_12(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),0,'div',[['class',
      'cf__original-preview']],[[8,'innerHTML',1]],(null as any),(null as any),(null as any),
      (null as any)))],(null as any),(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.sanatizedTemplateBodyHtml;
    _ck(_v,0,0,currVal_0);
  });
}
function View_CommsFormComponent_13(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),0,'div',[['class',
      'cf__editable-preview'],['contenteditable','true']],[[8,'innerHTML',1]],(null as any),
      (null as any),(null as any),(null as any)))],(null as any),(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.sanatizedTemplateBodyHtml;
    _ck(_v,0,0,currVal_0);
  });
}
function View_CommsFormComponent_14(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),0,'div',[['class',
      'cf__variable-preview']],[[8,'innerHTML',1]],(null as any),(null as any),(null as any),
      (null as any)))],(null as any),(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.sanatizedVariablePreviewHtml;
    _ck(_v,0,0,currVal_0);
  });
}
function View_CommsFormComponent_15(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),9,'div',[['class',
      'cf__sms-editor']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵeld(1,0,(null as any),(null as any),8,'div',[['class','input-row']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵeld(2,0,(null as any),(null as any),7,'div',[['class','input-group full']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵeld(3,0,(null as any),(null as any),6,'div',[['class','ig__content-wrapper']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵeld(4,0,(null as any),(null as any),5,'input',[['type','text']],
          [[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',
              (null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],
              [2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)]],[[(null as any),
              'ngModelChange'],[(null as any),'input'],[(null as any),'blur'],[(null as any),
              'compositionstart'],[(null as any),'compositionend']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i0.ɵnov(_v,5)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i0.ɵnov(_v,5).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i0.ɵnov(_v,5)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i0.ɵnov(_v,5)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_4:any = ((<any>(_co.editedTemplateBody = $event)) !== false);
              ad = (pd_4 && ad);
            }
            return ad;
          },(null as any),(null as any))),i0.ɵdid(5,16384,(null as any),0,i5.DefaultValueAccessor,
          [i0.Renderer2,i0.ElementRef,[2,i5.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i0.ɵprd(1024,(null as any),i5.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i5.DefaultValueAccessor]),i0.ɵdid(7,671744,(null as any),0,i5.NgModel,[[8,
          (null as any)],[8,(null as any)],[8,(null as any)],[2,i5.NG_VALUE_ACCESSOR]],
          {model:[0,'model']},{update:'ngModelChange'}),i0.ɵprd(2048,(null as any),
          i5.NgControl,(null as any),[i5.NgModel]),i0.ɵdid(9,16384,(null as any),0,
          i5.NgControlStatus,[i5.NgControl],(null as any),(null as any))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_7:any = _co.editedTemplateBody;
    _ck(_v,7,0,currVal_7);
  },(_ck,_v) => {
    const currVal_0:any = i0.ɵnov(_v,9).ngClassUntouched;
    const currVal_1:any = i0.ɵnov(_v,9).ngClassTouched;
    const currVal_2:any = i0.ɵnov(_v,9).ngClassPristine;
    const currVal_3:any = i0.ɵnov(_v,9).ngClassDirty;
    const currVal_4:any = i0.ɵnov(_v,9).ngClassValid;
    const currVal_5:any = i0.ɵnov(_v,9).ngClassInvalid;
    const currVal_6:any = i0.ɵnov(_v,9).ngClassPending;
    _ck(_v,4,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6);
  });
}
function View_CommsFormComponent_6(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),21,'div',[['class',
      'cf__preview-wrapper']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i0.ɵeld(1,0,(null as any),(null as any),5,'h3',[['class',
      'cf__preview-label']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i0.ɵted(-1,(null as any),['Preview'])),(_l()(),i0.ɵand(16777216,
      (null as any),(null as any),1,(null as any),View_CommsFormComponent_7)),i0.ɵdid(4,
      16384,(null as any),0,i1.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i0.ɵand(16777216,(null as any),(null as any),
      1,(null as any),View_CommsFormComponent_8)),i0.ɵdid(6,16384,(null as any),0,
      i1.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CommsFormComponent_9)),
      i0.ɵdid(8,16384,(null as any),0,i1.NgIf,[i0.ViewContainerRef,i0.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i0.ɵeld(9,0,(null as any),(null as any),
          12,'div',[['class','cf__preview-inner-wrapper']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i0.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_CommsFormComponent_10)),i0.ɵdid(11,16384,
          (null as any),0,i1.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,'ngIf']},
          (null as any)),(_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),
          View_CommsFormComponent_11)),i0.ɵdid(13,16384,(null as any),0,i1.NgIf,[i0.ViewContainerRef,
          i0.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),i0.ɵand(16777216,
          (null as any),(null as any),1,(null as any),View_CommsFormComponent_12)),
      i0.ɵdid(15,16384,(null as any),0,i1.NgIf,[i0.ViewContainerRef,i0.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i0.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_CommsFormComponent_13)),i0.ɵdid(17,16384,
          (null as any),0,i1.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,'ngIf']},
          (null as any)),(_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),
          View_CommsFormComponent_14)),i0.ɵdid(19,16384,(null as any),0,i1.NgIf,[i0.ViewContainerRef,
          i0.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),i0.ɵand(16777216,
          (null as any),(null as any),1,(null as any),View_CommsFormComponent_15)),
      i0.ɵdid(21,16384,(null as any),0,i1.NgIf,[i0.ViewContainerRef,i0.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.isToggleVariablePreviewBtnVisible();
    _ck(_v,4,0,currVal_0);
    const currVal_1:any = _co.isSendButtonVisible();
    _ck(_v,6,0,currVal_1);
    const currVal_2:any = _co.isInVariablePreviewMode;
    _ck(_v,8,0,currVal_2);
    const currVal_3:any = _co.isEditablePreviewVisible();
    _ck(_v,11,0,currVal_3);
    const currVal_4:any = _co.isCustomiseButtonVisible();
    _ck(_v,13,0,currVal_4);
    const currVal_5:any = _co.isOriginalPreviewVisible();
    _ck(_v,15,0,currVal_5);
    const currVal_6:any = _co.isEditablePreviewVisible();
    _ck(_v,17,0,currVal_6);
    const currVal_7:any = _co.isVariablePreviewVisible();
    _ck(_v,19,0,currVal_7);
    const currVal_8:any = _co.isSmsEditorVisible();
    _ck(_v,21,0,currVal_8);
  },(null as any));
}
export function View_CommsFormComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),46,'div',[['class',
      'comms-form']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      i0.ɵdid(1,278528,(null as any),0,i1.NgClass,[i0.IterableDiffers,i0.KeyValueDiffers,
          i0.ElementRef,i0.Renderer],{klass:[0,'klass'],ngClass:[1,'ngClass']},(null as any)),
      i0.ɵpod(2,{'special-enquiry-email':0}),(_l()(),i0.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_CommsFormComponent_1)),i0.ɵdid(4,16384,
          (null as any),0,i1.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,'ngIf']},
          (null as any)),(_l()(),i0.ɵeld(5,0,(null as any),(null as any),39,'div',
          [['class','cf__content-wrapper']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i0.ɵeld(6,0,(null as any),(null as any),
          36,'div',[['class','cf__upper-form-wrapper']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i0.ɵeld(7,0,(null as any),
          (null as any),20,'div',[['class','input-row']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i0.ɵeld(8,0,(null as any),
          (null as any),9,'div',[['class','input-group']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i0.ɵeld(9,0,(null as any),
          (null as any),8,'div',[['class','ig__content-wrapper']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i0.ɵeld(10,0,(null as any),
          (null as any),5,'ng2-completer',[['id','term'],['name','term']],[[2,'ng-untouched',
              (null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],
              [2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',
                  (null as any)],[2,'ng-pending',(null as any)]],[[(null as any),'ngModelChange'],
              [(null as any),'selected']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i6.CommsFormComponent = _v.component;
            if (('ngModelChange' === en)) {
              const pd_0:any = ((<any>(_co.termSearchStr = $event)) !== false);
              ad = (pd_0 && ad);
            }
            if (('selected' === en)) {
              const pd_1:any = ((<any>_co.selectedTerm($event)) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },i2.View_CompleterCmp_0,i2.RenderType_CompleterCmp)),i0.ɵdid(11,12697600,
          (null as any),0,i3.CompleterCmp,[i4.CompleterService,i0.ChangeDetectorRef],
          {minSearchLength:[0,'minSearchLength'],openOnFocus:[1,'openOnFocus'],initialValue:[2,
              'initialValue'],datasource:[3,'datasource']},{selected:'selected'}),
      i0.ɵprd(1024,(null as any),i5.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i3.CompleterCmp]),i0.ɵdid(13,671744,(null as any),0,i5.NgModel,[[8,(null as any)],
          [8,(null as any)],[8,(null as any)],[2,i5.NG_VALUE_ACCESSOR]],{name:[0,'name'],
          model:[1,'model']},{update:'ngModelChange'}),i0.ɵprd(2048,(null as any),
          i5.NgControl,(null as any),[i5.NgModel]),i0.ɵdid(15,16384,(null as any),
          0,i5.NgControlStatus,[i5.NgControl],(null as any),(null as any)),(_l()(),
          i0.ɵeld(16,0,(null as any),(null as any),1,'label',[['for','term']],(null as any),
              (null as any),(null as any),(null as any),(null as any))),(_l()(),i0.ɵted(-1,
          (null as any),['Active Term'])),(_l()(),i0.ɵeld(18,0,(null as any),(null as any),
          9,'div',[['class','input-group two-thirds']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i0.ɵeld(19,0,(null as any),
          (null as any),8,'div',[['class','ig__content-wrapper']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i0.ɵeld(20,0,(null as any),
          (null as any),5,'ng2-completer',[['id','template'],['name','template']],
          [[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',
              (null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],
              [2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)]],[[(null as any),
              'ngModelChange'],[(null as any),'selected']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i6.CommsFormComponent = _v.component;
            if (('ngModelChange' === en)) {
              const pd_0:any = ((<any>(_co.templateSearchStr = $event)) !== false);
              ad = (pd_0 && ad);
            }
            if (('selected' === en)) {
              const pd_1:any = ((<any>_co.selectedTemplate($event)) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },i2.View_CompleterCmp_0,i2.RenderType_CompleterCmp)),i0.ɵdid(21,12697600,
          (null as any),0,i3.CompleterCmp,[i4.CompleterService,i0.ChangeDetectorRef],
          {minSearchLength:[0,'minSearchLength'],openOnFocus:[1,'openOnFocus'],datasource:[2,
              'datasource']},{selected:'selected'}),i0.ɵprd(1024,(null as any),i5.NG_VALUE_ACCESSOR,
          (p0_0:any) => {
            return [p0_0];
          },[i3.CompleterCmp]),i0.ɵdid(23,671744,(null as any),0,i5.NgModel,[[8,(null as any)],
          [8,(null as any)],[8,(null as any)],[2,i5.NG_VALUE_ACCESSOR]],{name:[0,'name'],
          model:[1,'model']},{update:'ngModelChange'}),i0.ɵprd(2048,(null as any),
          i5.NgControl,(null as any),[i5.NgModel]),i0.ɵdid(25,16384,(null as any),
          0,i5.NgControlStatus,[i5.NgControl],(null as any),(null as any)),(_l()(),
          i0.ɵeld(26,0,(null as any),(null as any),1,'label',[['for','template']],
              (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted(-1,(null as any),['Template'])),(_l()(),i0.ɵeld(28,0,(null as any),
          (null as any),10,'div',[['class','input-row']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i0.ɵeld(29,0,(null as any),
          (null as any),9,'div',[['class','input-group full recipient-picker']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i0.ɵeld(30,
          0,(null as any),(null as any),8,'div',[['class','ig__content-wrapper']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵeld(31,0,(null as any),(null as any),5,'ng2-completer',[['id','recipient-picker'],
          ['name','recipient-picker']],[[2,'ng-untouched',(null as any)],[2,'ng-touched',
          (null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],
          [2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',
              (null as any)]],[[(null as any),'ngModelChange'],[(null as any),'selected']],
          (_v,en,$event) => {
            var ad:boolean = true;
            var _co:i6.CommsFormComponent = _v.component;
            if (('ngModelChange' === en)) {
              const pd_0:any = ((<any>(_co.recipientSearchStr = $event)) !== false);
              ad = (pd_0 && ad);
            }
            if (('selected' === en)) {
              const pd_1:any = ((<any>_co.selectedRecipient($event)) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },i2.View_CompleterCmp_0,i2.RenderType_CompleterCmp)),i0.ɵdid(32,12697600,
          (null as any),0,i3.CompleterCmp,[i4.CompleterService,i0.ChangeDetectorRef],
          {pause:[0,'pause'],minSearchLength:[1,'minSearchLength'],clearSelected:[2,
              'clearSelected'],openOnFocus:[3,'openOnFocus'],datasource:[4,'datasource']},
          {selected:'selected'}),i0.ɵprd(1024,(null as any),i5.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i3.CompleterCmp]),i0.ɵdid(34,671744,(null as any),0,i5.NgModel,[[8,(null as any)],
          [8,(null as any)],[8,(null as any)],[2,i5.NG_VALUE_ACCESSOR]],{name:[0,'name'],
          model:[1,'model']},{update:'ngModelChange'}),i0.ɵprd(2048,(null as any),
          i5.NgControl,(null as any),[i5.NgModel]),i0.ɵdid(36,16384,(null as any),
          0,i5.NgControlStatus,[i5.NgControl],(null as any),(null as any)),(_l()(),
          i0.ɵeld(37,0,(null as any),(null as any),1,'label',[['for','recipient-picker']],
              (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted(-1,(null as any),['Select Recipients'])),(_l()(),i0.ɵand(16777216,
          (null as any),(null as any),1,(null as any),View_CommsFormComponent_2)),
      i0.ɵdid(40,16384,(null as any),0,i1.NgIf,[i0.ViewContainerRef,i0.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i0.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_CommsFormComponent_4)),i0.ɵdid(42,16384,
          (null as any),0,i1.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,'ngIf']},
          (null as any)),(_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),
          View_CommsFormComponent_5)),i0.ɵdid(44,16384,(null as any),0,i1.NgIf,[i0.ViewContainerRef,
          i0.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),i0.ɵand(16777216,
          (null as any),(null as any),1,(null as any),View_CommsFormComponent_6)),
      i0.ɵdid(46,16384,(null as any),0,i1.NgIf,[i0.ViewContainerRef,i0.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any))],(_ck,_v) => {
    var _co:i6.CommsFormComponent = _v.component;
    const currVal_0:any = 'comms-form';
    const currVal_1:any = _ck(_v,2,0,_co.isSendingSpecialEnquiryEmail);
    _ck(_v,1,0,currVal_0,currVal_1);
    const currVal_2:any = _co.isSuccessFlashVisible;
    _ck(_v,4,0,currVal_2);
    const currVal_10:any = 0;
    const currVal_11:any = true;
    const currVal_12:any = _co.terms[0];
    const currVal_13:any = _co.termCompleter;
    _ck(_v,11,0,currVal_10,currVal_11,currVal_12,currVal_13);
    const currVal_14:any = 'term';
    const currVal_15:any = _co.termSearchStr;
    _ck(_v,13,0,currVal_14,currVal_15);
    const currVal_23:any = 0;
    const currVal_24:any = true;
    const currVal_25:any = _co.templateCompleter;
    _ck(_v,21,0,currVal_23,currVal_24,currVal_25);
    const currVal_26:any = 'template';
    const currVal_27:any = _co.templateSearchStr;
    _ck(_v,23,0,currVal_26,currVal_27);
    const currVal_35:any = 500;
    const currVal_36:any = 1;
    const currVal_37:any = true;
    const currVal_38:any = true;
    const currVal_39:any = _co.recipientCompleter;
    _ck(_v,32,0,currVal_35,currVal_36,currVal_37,currVal_38,currVal_39);
    const currVal_40:any = 'recipient-picker';
    const currVal_41:any = _co.recipientSearchStr;
    _ck(_v,34,0,currVal_40,currVal_41);
    const currVal_42:any = (_co.recipients.length > 0);
    _ck(_v,40,0,currVal_42);
    const currVal_43:any = _co.isSendToPickerVisible();
    _ck(_v,42,0,currVal_43);
    const currVal_44:any = _co.isSendingSpecialEnquiryEmail;
    _ck(_v,44,0,currVal_44);
    const currVal_45:any = _co.isPreviewAreaVisible();
    _ck(_v,46,0,currVal_45);
  },(_ck,_v) => {
    const currVal_3:any = i0.ɵnov(_v,15).ngClassUntouched;
    const currVal_4:any = i0.ɵnov(_v,15).ngClassTouched;
    const currVal_5:any = i0.ɵnov(_v,15).ngClassPristine;
    const currVal_6:any = i0.ɵnov(_v,15).ngClassDirty;
    const currVal_7:any = i0.ɵnov(_v,15).ngClassValid;
    const currVal_8:any = i0.ɵnov(_v,15).ngClassInvalid;
    const currVal_9:any = i0.ɵnov(_v,15).ngClassPending;
    _ck(_v,10,0,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7,currVal_8,currVal_9);
    const currVal_16:any = i0.ɵnov(_v,25).ngClassUntouched;
    const currVal_17:any = i0.ɵnov(_v,25).ngClassTouched;
    const currVal_18:any = i0.ɵnov(_v,25).ngClassPristine;
    const currVal_19:any = i0.ɵnov(_v,25).ngClassDirty;
    const currVal_20:any = i0.ɵnov(_v,25).ngClassValid;
    const currVal_21:any = i0.ɵnov(_v,25).ngClassInvalid;
    const currVal_22:any = i0.ɵnov(_v,25).ngClassPending;
    _ck(_v,20,0,currVal_16,currVal_17,currVal_18,currVal_19,currVal_20,currVal_21,
        currVal_22);
    const currVal_28:any = i0.ɵnov(_v,36).ngClassUntouched;
    const currVal_29:any = i0.ɵnov(_v,36).ngClassTouched;
    const currVal_30:any = i0.ɵnov(_v,36).ngClassPristine;
    const currVal_31:any = i0.ɵnov(_v,36).ngClassDirty;
    const currVal_32:any = i0.ɵnov(_v,36).ngClassValid;
    const currVal_33:any = i0.ɵnov(_v,36).ngClassInvalid;
    const currVal_34:any = i0.ɵnov(_v,36).ngClassPending;
    _ck(_v,31,0,currVal_28,currVal_29,currVal_30,currVal_31,currVal_32,currVal_33,
        currVal_34);
  });
}
export function View_CommsFormComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'comms-form',
      ([] as any[]),(null as any),(null as any),(null as any),View_CommsFormComponent_0,
      RenderType_CommsFormComponent)),i0.ɵdid(1,245760,(null as any),0,i6.CommsFormComponent,
      [i7.Store,i8.Actions,i9.Router,i9.ActivatedRoute,i4.CompleterService,i10.Angular2TokenService,
          i11.DomSanitizer,i0.ElementRef],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const CommsFormComponentNgFactory:i0.ComponentFactory<i6.CommsFormComponent> = i0.ɵccf('comms-form',
    i6.CommsFormComponent,View_CommsFormComponent_Host_0,{mode:'mode'},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/$$_gendir/app/components/comms-form.ngfactory.ts